import React from "react";

function FieldNoteDetails({ fieldNote }) {
  const media = Array.isArray(fieldNote.media) ? fieldNote.media : [];

  return (
    <div className="tab-pane fade show active package-info-tab">
      {media.length > 0 && (
        <div className="fieldnote-gallery" aria-label={`Images for ${fieldNote.title}`}>
          {media.map((imageUrl, index) => (
            <img
              key={`${imageUrl}-${index}`}
              src={imageUrl}
              alt={`${fieldNote.title} by ${fieldNote.name}, image ${index + 1}`}
              loading={index === 0 ? "eager" : "lazy"}
            />
          ))}
        </div>
      )}

      <div
        className="workshop_bodytext has-bg-image fieldnote-body"
        dangerouslySetInnerHTML={{ __html: fieldNote.body || "" }}
      />

      <section className="fieldnote-biography has-bg-image" aria-labelledby="fieldnote-biography-title">
        <h3 id="fieldnote-biography-title" className="d-subtitle has-bg-image">
          About {fieldNote.name}
        </h3>

        <div
          className="workshop_bodytext has-bg-image fieldnote-biography-text"
          dangerouslySetInnerHTML={{ __html: fieldNote.biog || "" }}
        />

        {fieldNote.link && (
          <a
            className="button-outlined-primary fieldnote-author-link"
            href={fieldNote.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit {fieldNote.name}&apos;s website or profile
            <i className="bi bi-box-arrow-up-right" />
          </a>
        )}
      </section>
    </div>
  );
}

export default FieldNoteDetails;
